export const UPDATE_UPCOMING_EVENTS = 'UPDATE_UPCOMING_EVENTS';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';
